define(['exports', 'react', 'prop-types', 'lodash', '../../i18n', '../common/Field', '../common/Button', '../common/PasswordCriteria', '../common/Errors', '../../assets/correct.svg', '../../assets/Logo-vertical.svg'], function (exports, _react, _propTypes, _lodash, _i18n, _Field, _Button, _PasswordCriteria, _Errors, _correct, _LogoVertical) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _lodash2 = _interopRequireDefault(_lodash);

  var _i18n2 = _interopRequireDefault(_i18n);

  var _Field2 = _interopRequireDefault(_Field);

  var _Button2 = _interopRequireDefault(_Button);

  var _PasswordCriteria2 = _interopRequireDefault(_PasswordCriteria);

  var _Errors2 = _interopRequireDefault(_Errors);

  var _correct2 = _interopRequireDefault(_correct);

  var _LogoVertical2 = _interopRequireDefault(_LogoVertical);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ForgetPasswordView = function (_Component) {
    _inherits(ForgetPasswordView, _Component);

    function ForgetPasswordView(props) {
      _classCallCheck(this, ForgetPasswordView);

      var _this = _possibleConstructorReturn(this, (ForgetPasswordView.__proto__ || Object.getPrototypeOf(ForgetPasswordView)).call(this, props));

      _this.state = {
        showErrors: false
      };
      return _this;
    }

    _createClass(ForgetPasswordView, [{
      key: 'handleInitiateForgetPassword',
      value: function handleInitiateForgetPassword() {
        var _props = this.props,
            errors = _props.login.errors,
            initiateForgetPassword = _props.initiateForgetPassword;

        this.setState({ showErrors: true });
        !(errors && errors.validation && errors.validation.email) && initiateForgetPassword();
      }
    }, {
      key: 'renderErrors',
      value: function renderErrors() {
        var errors = this.props.login.errors;

        return _react2.default.createElement(_Errors2.default, { errors: [errors.recoverPassword] });
      }
    }, {
      key: 'renderSendEmailView',
      value: function renderSendEmailView() {
        var _this2 = this;

        var _props2 = this.props,
            _props2$login = _props2.login,
            email = _props2$login.email,
            errors = _props2$login.errors,
            updateEmail = _props2.updateEmail;


        var emailError = errors.validation && errors.validation.email ? _i18n2.default.t('dk-ui-lib.errors.login.email') : '';
        var showErrors = this.state.showErrors;


        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'mb3' },
            errors.recoverPassword && this.renderErrors()
          ),
          _react2.default.createElement(
            'div',
            { className: 'mb1 h3 bold' },
            _i18n2.default.t('dk-ui-lib.login.recover_password')
          ),
          _react2.default.createElement(
            'div',
            { className: 'mb2' },
            _react2.default.createElement(_Field2.default, {
              placeholder: _i18n2.default.t('dk-ui-lib.login.enter_email_id'),
              inputType: 'text',
              value: email,
              shouldHideValidationIcon: true,
              errorPosition: 'bottom',
              onChange: updateEmail,
              onEnter: function onEnter() {
                return _this2.handleInitiateForgetPassword();
              },
              msgs: { error: showErrors && emailError } })
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex items-center flex-column' },
            _react2.default.createElement(_Button2.default, {
              type: 'primary',
              buttonStyle: { padding: '0.7rem' },
              label: _i18n2.default.t('dk-ui-lib.buttons.send_mail'),
              labelStyle: { fontSize: '1rem' },
              onClick: function onClick() {
                return _this2.handleInitiateForgetPassword();
              } })
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex mt2' },
            _react2.default.createElement(
              'div',
              null,
              _i18n2.default.t('dk-ui-lib.login.to_login'),
              ':'
            ),
            _react2.default.createElement(
              'div',
              { className: 'secondary ml1 clickable',
                onClick: function onClick() {
                  return _this2.redirectToLoginRoute();
                }
              },
              _i18n2.default.t('dk-ui-lib.login.click_here')
            )
          )
        );
      }
    }, {
      key: 'redirectToLoginRoute',
      value: function redirectToLoginRoute() {
        var _props3 = this.props,
            history = _props3.history,
            routePath = _props3.routePath;

        history.push(routePath.rootRoute);
        return;
      }
    }, {
      key: 'renderSentEmailView',
      value: function renderSentEmailView(email) {
        var _this3 = this;

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'mb1 h3 bold' },
            _i18n2.default.t('dk-ui-lib.login.recover_password')
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex' },
            _react2.default.createElement(_correct2.default, { className: 'svg-icon svg-1x' }),
            _react2.default.createElement(
              'div',
              { className: 'ml2', style: { marginTop: '0.2rem' } },
              _i18n2.default.t('dk-ui-lib.login.link_mailed')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'my2' },
            _react2.default.createElement(
              'span',
              null,
              _i18n2.default.t('dk-ui-lib.login.recover_password_desk_1')
            ),
            _react2.default.createElement(
              'span',
              { className: 'ml1 brand-color' },
              email
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _i18n2.default.t('dk-ui-lib.login.recover_password_desk_2')
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex items-center flex-column mt2' },
            _react2.default.createElement(_Button2.default, {
              type: 'primary',
              buttonStyle: { padding: '0.7rem' },
              label: _i18n2.default.t('dk-ui-lib.buttons.back_to_login'),
              labelStyle: { fontSize: '1rem' },
              onClick: function onClick() {
                return _this3.redirectToLoginRoute();
              } })
          )
        );
      }
    }, {
      key: 'render',
      value: function render() {
        var _props$login = this.props.login,
            hasEmailSent = _props$login.hasEmailSent,
            _props$login$email = _props$login.email,
            email = _props$login$email === undefined ? 'your registered email' : _props$login$email;

        return _react2.default.createElement(
          'div',
          { className: 'col-6 px4' },
          _react2.default.createElement(
            'div',
            { className: 'mt3 mb1 center' },
            _react2.default.createElement(_LogoVertical2.default, null)
          ),
          _react2.default.createElement(
            'div',
            { level: 1, className: 'p4 mx2 my1 h5 white-background' },
            hasEmailSent ? this.renderSentEmailView(email) : this.renderSendEmailView()
          )
        );
      }
    }]);

    return ForgetPasswordView;
  }(_react.Component);

  exports.default = ForgetPasswordView;


  ForgetPasswordView.propTypes = {
    login: _propTypes2.default.object.isRequired,
    hasEmailSent: _propTypes2.default.bool,
    updateEmail: _propTypes2.default.func.isRequired,
    updateNewPassword: _propTypes2.default.func.isRequired,
    updateConfirmNewPassword: _propTypes2.default.func.isRequired,
    resetPassword: _propTypes2.default.func.isRequired,
    initiateForgetPassword: _propTypes2.default.func.isRequired

  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/forget-password/index.js
// module id = 1177
// module chunks = 0